import { handleActions } from "redux-actions";

const updatePortfoliosLogoUrl = (portfolios, company) =>
  portfolios.map((p) => {
    let portfolio = { ...p };
    if (p.company.id === company.id) {
      portfolio = { ...p, company: { ...p.company, logoUrl: company.logoUrl } };
    }

    return portfolio;
  });

const companyReducer = handleActions(
  {
    COMPANIES_GET: {
      FULFILLED: (_state, action) => ({
        companies: action.payload.companies,
      }),
    },

    COMPANY_GET: {
      FULFILLED: (_state, action) => ({
        company: action.payload.company,
      }),
    },

    COMPANY_SAVE: {
      FULFILLED: (state, action) => ({
        company: action.payload.company,
        currentUser: { ...state.currentUser, company: action.payload.company },
        portfolios: updatePortfoliosLogoUrl(state.portfolios, action.payload.company),
      }),
    },

    COMPANY_CREATE: {
      FULFILLED: (state, action) => ({
        currentUser: { ...state.currentUser, company: action.payload.company },
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default companyReducer;
